import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const PlayerLanguageModalText = styled.span<{ focused: boolean }>`
  color: ${(props) =>
    props.focused ? Colors['text'] : Colors['modal']['grey']};
  cursor: pointer;
  font-family: ${Fonts['regular']};
  font-size: ${37 * Screen.widthRatio}px;
  margin-bottom: ${52 * Screen.widthRatio}px;
  position: relative;
`;

export default PlayerLanguageModalText;
